import { Action } from '../../../action';
import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setGetReplenishmentUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_REPLENISHMENT
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetReplenishmentUserAction({
                    data: data.data,
                    count: data.count
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetReplenishmentUser as SetGetReplenishmentUser
}